// https://vuex.vuejs.org/en/state.html
// TODO  obtener token try - catch, JSON parse error
export default {
  drawer: false,
  titleAppBar: '',
  token: JSON.parse(localStorage.getItem('token')) || null,
}
